import React from 'react'
import { ActionPromptItem } from '../ActionPromptItem'
import { AccountDetails, Product } from '../../../../types'
import { ViewRatesModal } from './ViewRatesModal'
import { pastBestRate } from '../../../../utils/pastBestRate'
import { getCDFrequency } from '../../../../utils/getCDFrequency'

export const ViewRatesActionPrompt: React.FC<{
  account: AccountDetails
  product: Product | undefined
}> = ({ account, product }) => {
  const { cdTermDescription, currentBalancePvtEncrypt } = account

  // istanbul ignore next
  if (!product) return null

  // istanbul ignore next
  if (account.accountStatus.toLowerCase() === 'closed') {
    return null
  }

  const productTerm =
    product.terms.find(
      term => term.term === getCDFrequency(cdTermDescription),
    ) || null
  const { interestRates } = productTerm || {}

  // istanbul ignore next
  if (!interestRates) return null

  const isBalanceGreaterThanZero = currentBalancePvtEncrypt > 0
  const showViewRatesUnfunded =
    pastBestRate(account) && !isBalanceGreaterThanZero
  if (showViewRatesUnfunded) {
    return (
      <ActionPromptItem>
        On the date you fund your CD, you&apos;ll receive the current rate we
        offer. <ViewRatesModal interestRates={interestRates} />
      </ActionPromptItem>
    )
  }

  // istanbul ignore next
  return null
}
